import classNames from 'classnames';
import React from 'react';

import { Banner, BANNER_TYPES } from '@sravni/react-advertisement';
import { IdleSpecialOffersPopup } from '@sravni/react-ugc/lib/IdleSpecialOffersPopup';
import { useAnalytics, useIsMobile } from '@sravni/react-utils';

import { useBanners, useIsLoadedBanners } from '@store/hooks/advertising';
import { useIsUserLogged } from '@store/hooks/users';
import { isShowPopupWithSO } from '@utils/isShowPopupWithSO';

import { useGenerateTabs } from '../../hooks/useGenerateTabsForSpecialOffers';
import { AB_NAME } from '../../pages/_app';
import { AboutBlock } from '../AboutBlock';
import { GiveFeedback } from '../GiveFeedback';
import { RatingsTable } from '../RatingsTable';
import { SeoBlocks } from '../SeoBlocks';
import { SpecialOffersBlock } from '../SpecialOffersBlock';

import styles from './ratings-content.module.scss';

export const RatingsContent = React.memo(() => {
  const isMobile = useIsMobile();
  const banners = useBanners();
  const isLoadedBanners = useIsLoadedBanners();
  const isUserLogged = useIsUserLogged();
  const { pushEvent } = useAnalytics();
  const tabs = useGenerateTabs();

  return (
    <>
      <div className={styles.wrapper}>
        <div className={styles.content}>
          <div>
            <AboutBlock />
            {isMobile && (!isLoadedBanners || banners?.[BANNER_TYPES.TGBM_7]) && (
              <Banner
                banner={banners?.[BANNER_TYPES.TGBM_7]}
                type={BANNER_TYPES.TGBM_7}
                className={classNames(styles.advertising, styles['advertising--tgbm7'])}
                abName={AB_NAME}
              />
            )}
            <RatingsTable />
            {!isMobile && (!isLoadedBanners || banners?.[BANNER_TYPES.TGBM_7]) && (
              <Banner
                banner={banners?.[BANNER_TYPES.TGBM_7]}
                type={BANNER_TYPES.TGBM_7}
                className={classNames(styles.advertising, styles['advertising--tgbm7'])}
                abName={AB_NAME}
              />
            )}
            {isMobile && (!isLoadedBanners || banners?.[BANNER_TYPES.SIDE]) && (
              <Banner
                banner={banners?.[BANNER_TYPES.SIDE]}
                type={BANNER_TYPES.SIDE}
                className={classNames(styles.advertising, styles['advertising--aside'])}
                abName={AB_NAME}
              />
            )}
            <div className={styles.innerWrapper}>
              <SpecialOffersBlock tabs={tabs} />
            </div>
          </div>

          {!isMobile && (
            <aside>
              <GiveFeedback />

              <div className={styles.sticky}>
                {(!isLoadedBanners || banners?.[BANNER_TYPES.SIDE]) && (
                  <Banner
                    banner={banners?.[BANNER_TYPES.SIDE]}
                    type={BANNER_TYPES.SIDE}
                    className={classNames(styles.advertising, styles['advertising--aside'])}
                    abName={AB_NAME}
                  />
                )}
              </div>
            </aside>
          )}
        </div>
      </div>
      <div className={styles.wrapper}>
        <div className={styles.innerWrapper}>
          <SeoBlocks />
        </div>
      </div>
      {isShowPopupWithSO && (
        <IdleSpecialOffersPopup
          abName={AB_NAME}
          tabs={tabs}
          section={'Рейтинг'}
          pushEvent={pushEvent}
          isUserLogged={isUserLogged}
        />
      )}
    </>
  );
});
